import Env from "../base/env";
import Channels from "../base/channels";
import Component from "gia/Component";
import { RevealFade } from "../fx/Common";

export default class ContactForm extends Component {
  mount() {
    this.DOM = {};
    this.DOM.formContainer = this.element.querySelector(".wpcf7");
    this.DOM.formElement = this.DOM.formContainer.querySelector("form");
    this.DOM.formSubmit = this.DOM.formContainer.querySelector(".apply-submit");
    this.DOM.formSubmitContainer =
      this.DOM.formContainer.querySelector(".submit-container");

    if (Env.isVisiting == true) {
      wpcf7.init(this.DOM.formElement);
    }

    this.tracking();

    this.events();
    this.customFieldFile();
  }

  customFieldFile() {
    var inputs = document.querySelectorAll(".field-file");
    Array.prototype.forEach.call(inputs, function (input) {
      const label = input.parentElement.parentElement.querySelector("label");
      const labelVal = label.innerHTML;

      input.addEventListener("change", function (e) {
        var fileName = "";
        if (this.files && this.files.length > 1) {
          fileName = (this.getAttribute("data-multiple-caption") || "").replace(
            "{count}",
            this.files.length
          );
        } else {
          fileName = e.target.value.split("\\").pop();
        }
        if (fileName) {
          label.querySelector(".js-filename").innerHTML = fileName;
        } else {
          label.innerHTML = labelVal;
        }
      });
    });
  }

  events() {
    this.DOM.formContainer.addEventListener(
      "wpcf7submit",
      function (event) {
        setTimeout(() => {
          if (typeof Env.framework.UI.smoothie != "undefined") {
            Env.framework.UI.smoothie.update();
          }
        }, 250);
      },
      false
    );

    setInterval(() => {
      if (this.DOM.formSubmit.disabled) {
        this.DOM.formSubmitContainer.classList.add("disabled");
      } else {
        this.DOM.formSubmitContainer.classList.remove("disabled");
      }
    }, 60);
  }

  tracking() {
    var wpcf7Elm = document.querySelector(".wpcf7");

    this.DOM.formElement.addEventListener("wpcf7mailsent", (event) => {
      const formData = event.detail.formData;
      for (let [k, v] of formData) {
        console.log(k, v);
      }

      // prettier-ignore
      var newLead = {
        "Full name": formData.get('contact-name'),
        "Emails": formData.get('email'),
        "Email": formData.get('email'),
        "Product":formData.get('subject'),
        "Inquiry":formData.get('message'),
        "Subscription status":formData.get('acceptance-newsletter'),
        "Contact type":formData.get('contact-type'),
        "Source":"Web Form"
      };
      var identifier = formData.get("email");
      setTimeout(() => {
        console.info("lead created", newLead);
        fwcrm.identify(identifier, newLead);
      }, 1000);
    });
  }
}
